import { useMainAppSettingItemValue } from '@repo/ccc-main-app-lib/src/lib/mainAppSettings.ts'
import { BankPageV1 } from '@repo/ccc-main-app-lib/src/pages/BankPageV1.tsx'
import { BankPageV2 } from '@repo/ccc-main-app-lib/src/pages/BankPageV2.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/bank')({
  component: UserBankPage,
})

function UserBankPage() {
  const { userId } = Route.useParams()

  const shouldUseBankPageV2 = useMainAppSettingItemValue(
    'featureFlags.bank.enableBankPageV2',
  )

  if (shouldUseBankPageV2) return <BankPageV2 userId={userId} />

  return <BankPageV1 userId={userId} />
}
